<template lang="pug">
.form-order.center
  .section-title(@click="show.data = !show.data")
    h3.capitalize Datos Generales

  transition(name="slide-fade")
    .section-container(v-if="show.data")
      form(@submit.prevent="" autocomplete="off")
        .form-section
          .input-container(v-if="dataForm.isWholesaler")
            input.input(v-model="dataForm.isWholesaler" autocomplete="ño" :disabled="true" required)
            label.label.disabled(:class="{ show: dataForm.isWholesaler }")
              shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="isWholesaler" title="Es Mayorista")

          .input-container(v-if="dataForm.isDropshipping")
            input.input(v-model="dataForm.isDropshipping" autocomplete="ño" :disabled="true" required)
            label.label.disabled(:class="{ show: dataForm.isDropshipping }")
              shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="isDropshipping" title="Es Dropshipping")

        .form-section
          .input-container
            input.input(v-model="dataForm.dni" type="number" :disabled="true" autocomplete="ño")
            label.label(:class="{ show: dataForm.dni }")
              shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="dni" title="Documento")
          .input-container
            input.input(v-model="dataForm.name" autocomplete="ño" :disabled="true" required)
            label.label(:class="{ show: dataForm.name }")
              shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="name" title="Nombre")

        .form-section
          shInputList(:dataForm="dataForm" :dataOriginal="dataOriginal" title="teléfono" property="phones" pattern="[0-9]{10}" :required="1" :disabled="buyerDataLocked")

        .form-section
          .input-container
            input.input(v-model="dataForm.email" type="email" autocomplete="ño" required)
            label.label(:class="{ show: dataForm.email }")
              shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="email" title="email")

          .input-container
            input.input(v-model="dataForm.location" autocomplete="ño" :disabled="buyerDataLocked" required)
            label.label(:class="{ show: dataForm.location, disabled: buyerDataLocked }")
              shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="location" title="Ciudad o Municipio")

          .input-container
            input.input(v-model="dataForm.department" autocomplete="ño" :disabled="buyerDataLocked" required)
            label.label(:class="{ show: dataForm.department, disabled: buyerDataLocked }")
              shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="department" title="Departamento")

          .input-container
            label.label(:class="{ show: dataForm.address, disabled: buyerDataLocked }")
              shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="address" title="Dirección")
            textarea.input(v-model="dataForm.address" autocomplete="ño" rows="5" :disabled="buyerDataLocked" required)

          .input-container.arrow
            label.label(:class="{ show: dataForm.community }")
              shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="community" title="Localidad")
            select.select.capitalize(v-model="dataForm.community" autocomplete="ño")
              option.capitalize(v-for="community in communities" :value="community") {{ community }}

          .input-container
            input.input(v-model="dataForm.tracking" autocomplete="ño" type="number")
            label.label(:class="{ show: dataForm.tracking }")
              shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="tracking" title="Número de Guía del Cliente")

        .form-section
          .input-container
            select.select(v-model="dataForm.conveyor" autocomplete="ño" required)
              option(v-for="conveyor in conveyors" :value="conveyor") {{ capitalize(conveyor) }}
            label.label(:class="{ show: dataForm.conveyor }")
              shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="conveyor" title="Transportadora")

          .input-container
            input.input(v-model.number="dataForm.conveyorCost" autocomplete="ño" required)
            label.label(:class="{ show: dataForm.conveyorCost >= 0 }")
              shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="conveyorCost" title="Costo de la Transportadora")

        .form-section.form-order-actions
          shActionButton(:isForm="true" :text="fillData ? 'Actualizar' : 'Guardar'" :textRunning="fillData ? 'Actualizando' : 'Guardando'" :action="sendForm")
          shActionButton(v-if="fillData && buyerDataLocked" :action="unlockChangeData" text="Desbloquear" textRunning="Desbloqueando" :textConfirmation="unlockChangeDataConfirmation")
          shActionButton(v-if="fillData && hasRemit" :action="printRemit" text="Imprimir" textRunning="Imprimiendo")

  .section-title(@click="show.products = !show.products")
    h3.capitalize Productos Originales ({{totals.quantity}}) {{ dataForm.isSale ? '(Promoción)' : ''}} {{ money(total - discount + addons) }}

  transition(name="slide-fade")
    .section-container(v-if="show.products")
      h3.capitalize {{ text.subtitles.total }} ({{totals.quantity}}) {{ money(total - discount + addons) }}
      .products-order-container
        shProduct(v-for="product in dataForm.originalProducts" :key="product.product" :order="dataForm" :quantity="totals.quantity" :product="product" @updateProduct="updateProduct" :subtract="dataForm.status === 'created' || dataForm.status === 'approved'" :pick="dataForm.status === 'paid'" :hideAddAndSubtract="true" :hidePack="true" :quantitySale="dataForm.quantitySale")

  .section-title(@click="show.dataChange = !show.dataChange")
    h3.capitalize Datos de Cambio

  transition(name="slide-fade")
    .section-container(v-if="show.dataChange")
      form(@submit.prevent="" autocomplete="off")
        .input-container
          select.select(v-model="dataForm.conveyorCustomer" autocomplete="ño" required)
            option(v-for="conveyor in conveyors" :value="conveyor") {{ capitalize(conveyor) }}
          label.label(:class="{ show: dataForm.conveyorCustomer }")
            shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="conveyorCustomer" title="Transportadora Del Cliente")

        .input-container
          input.input(v-model="dataForm.tracking" autocomplete="ño" type="number")
          label.label(:class="{ show: dataForm.tracking }")
            shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="tracking" title="Número de Guía Del Cliente")

        .checkbox-section
          .input-container-checkbox
            label.label-checkbox(:for="`conveyorPaidByCompany${dataForm.charge}`")
              shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="conveyorPaidByCompany" title="Transporte pagado por Sahet")
              input.input-checkbox(v-model="dataForm.conveyorPaidByCompany" :id="`conveyorPaidByCompany${dataForm.charge}`" type="checkbox")
              .checkmark

        shActionButton(:isForm="true" :text="fillData ? 'Actualizar' : 'Guardar'" :textRunning="fillData ? 'Actualizando' : 'Guardando'" :action="sendForm")

  .section-title(@click="showSection('productsChange')" name="SectionTitle")
    h3.capitalize Cambio ({{totals1.quantity}}) {{ dataForm.isSale ? '(Promoción)' : ''}} {{ money(total1 - discount + addons) }}

    .buttons-product
      shActionButton(text="Copiar URL" textRunning="Copiar URL" :action="copyChange" :mini="true")

  transition(name="slide-fade")
    .section-container(v-if="show.productsChange")
      h3.capitalize {{ text.subtitles.total }} ({{totals.quantity}}) {{ money(total - discount + addons) }}
      .products-order-container
        shProduct(v-for="product in dataForm.newProducts" :key="product.product" :change="dataForm" :quantity="totals.quantity" :product="product" @updateProduct="updateProduct" :subtract="dataForm.status === 'created'" :pick="dataForm.status === 'paid'" :isChange="true" :quantitySale="dataForm.quantitySale")

      div(v-if="dataForm.status === 'paid'")
        form(@submit.prevent="")
          .input-container
            input.input(v-model="productCheck" @keypress.enter.prevent="checkProduct" autocomplete="ño" required)
            label.label(:class="{ show: productCheck }") Ingresa el Código Del Producto
          shActionButton(:isForm="true" :action="checkProduct" :params="[product]" text="Revisar Producto" textRunning="Revisando Producto" :normalColor="true")

      .products-order-container(v-if="dataForm.status === 'created' || dataForm.status === 'approved'")
        shProduct(v-for="(product, index) in addProducts" :key="product.product" :order="dataForm" :change="dataForm" :quantity="totals.quantity" :product="product" :add="true" @updateProduct="updateProduct" :isChange="true" :hideChangePrice="true")

      div(v-if="dataForm.status === 'created' || dataForm.status === 'approved'")
        .input-container
          input.input(v-model="product" @keypress.enter.prevent="addProduct" autocomplete="ño")
          label.label(:class="{ show: product }") Escribe la referencia
        shActionButton(:action="addProduct" text="Buscar Producto" textRunning="Buscando Producto")

  .section-title(@click="show.observations = !show.observations")
    h3.capitalize Observaciones {{dataForm.observations && dataForm.observations.length ? `(${dataForm.observations.length})` : '' }}

  transition(name="slide-fade")
    .section-container(v-if="show.observations")
      .observations-container
        .observation.list-items.dark.capitalize(v-if="dataForm.observations && dataForm.observations.length")
          .observation-observation Observación
          .observation-type Tipo
          .observation-created-at Fecha Creación
          .observation-created-by Creado Por
        .observation.list-items(v-for="(observation, index) in dataForm.observations" :key="observation.createdAt" v-if="observation")
          .observation-observation {{ index + 1 }}. {{ observation.observation }}
          .observation-type {{ observation.type }}
          .observation-created-at {{ dateTime(observation.createdAt) }}
          shNameUser.observation-created-by(:dni="observation.createdBy")

      form(@submit.prevent="")
        .input-container
          textarea.input(v-model="observation.observation" autocomplete="ño" rows="3" required)
          label.label.capitalize(:class="{ show: observation.observation }") {{ text.labels.observation }}

        .input-container.arrow.arrow-icon
          select.select.capitalize(v-model="observation.type" autocomplete="ño" required)
            option(value="" select)
            option(value="delivery") Entrega
            option(value="pay") Pago
            option(value="product") Producto
          label.label.capitalize(:class="{ show: observation.type }") Tipo

        shActionButton(:isForm="true" :action="addObservation" text="Agregar Observación" textRunning="Agregando Observación" :normalColor="true")

  .section-title(@click="show.pay = !show.pay")
    h3
      span.capitalize Pagos
      span.color-red(v-if="total1 - total - totalPayManual + (dataOriginal.conveyorPaidByCompany ? 0 : addons) > 0")  (- {{ money(total1 - total - totalPayManual + (dataOriginal.conveyorPaidByCompany ? 0 : addons)) }})
      span.color-green(v-else)  ({{ money(total1 - total - totalPayManual + (dataOriginal.conveyorPaidByCompany ? 0 : addons)) }})

  transition(name="slide-fade")
    .section-container(v-if="show.pay")
      .pay-u-container(v-if="false")
        h3 Pagos Automáticos ({{ money(totalPayU) }})

        .list-items.dark.capitalize
          .item-pay-u Id
          .item-pay-u Método
          .item-pay-u Estado
          .item-pay-u valor
          .item-pay-u Creación
          .item-pay-u Revisado
          .item-pay-u Acciones

        .list-items(v-for="(pay, index) in dataOriginal.payU")
          .item-pay-u
            .item-pay-u-order-id {{ pay.orderId || 'No Id'  }}
            img.platform-pay-image(:src="`https://sahet-cdn.b-cdn.net/img/others/light/${ pay.platform || 'payu'}.png`" :class="{epayco: pay.platform }")
          .item-pay-u
            div
              img.method-pay-image(:src="`${imagePath}/methods/light/${pay.methodPay}.png`" :alt="pay.methodPay")
            div(v-if="pay.methodPay === 'daviplata'") {{ pay.daviplataPhone }}
            div(v-if="pay.methodPay === 'nequi'") {{ pay.nequiPhone }}
          .item-pay-u(:class="{'color-green': pay.state === 'approved', 'color-red': pay.state !== 'approved' && pay.state !== 'created'}")
            .capitalize {{ statesSpanish[pay.state] || 'invalida' }}
            div(v-if="pay.methodPay === 'daviplata' && pay.state === 'pending' && pay.tokenExpirationDate")
              div Vence:
              div {{ dateTime(pay.tokenExpirationDate, true) }}
            .capitalize(v-if="pay.error") {{ pay.error }}
          .item-pay-u {{ money(pay.value || 0) }}
          .item-pay-u {{ dateTime(pay.createdAt) }}
          .item-pay-u {{ dateTime(pay.checkedAt || pay.createdAt) }}
          .item-pay-u
            shActionButton(v-if="pay.orderId" :action="checkStatePayU" :params="[index, pay.platform]" text="Actualizar" textRunning="Actualizando")

      .pay-manual.container
        h3.capitalize Pagos Manuales ({{ money(totalPayManual) }})

        .list-items.dark.capitalize
          .item-pay-manual Id
          .item-pay-manual {{ text.tables.methodPay }}
          .item-pay-manual {{ text.tables.state }}
          .item-pay-manual {{ text.tables.value }}
          .item-pay-manual {{ text.tables.createdAt }}
          .item-pay-manual {{ text.tables.createdBy }}
          .item-pay-manual {{ text.tables.actions }}

        .list-items(v-for="(pay, index) in dataOriginal.payManual")
          .item-pay-manual {{ index + 1 }}
          .item-pay-manual
            img.method-pay-image(:src="`${imagePath}/methods/light/${pay.methodPay}.png`" :alt="pay.methodPay")
          .item-pay-manual(:class="{'color-green': pay.state === 'approved', 'color-red': pay.state === 'declined'}") {{ pay.state }}
          .item-pay-manual {{ money(pay.value || 0) }}
          .item-pay-manual {{ dateTime(pay.createdAt) }}
          shNameUser.item-pay-manual(:dni="pay.createdBy")
          .item-pay-manual
            shActionButton(v-if="pay.state !== 'declined'"  :action="declinePayManual" :params="[index]" text="Declinar" textRunning="Declinando")
            shActionButton(v-if="pay.state === 'pending'" :action="approvePayManual" :params="[index]" text="Aprobar" textRunning="Aprobando")

        form.add-manual-pays(v-if="dataForm.status === 'created' || dataForm.status === 'approved'" @submit.prevent="")
          .input-container.arrow
            select.select(v-model="manualPay.methodPay" autocomplete="ño" required)
              option(v-for="method in methods" :value="method") {{ capitalize(method) }}
            label.label(:class="{ show: manualPay.methodPay }") Método de Pago

          .input-container
            input.input(v-model.number="manualPay.value" type="number" min="1" max="10000000" autocomplete="ño" required)
            label.label.capitalize(:class="{ show: manualPay.value }") Valor

          shActionButton.button-pay(:isForm="true" :action="addPayManual" text="Agregar Pago" textRunning="Agregando Pago" :normalColor="true")

  .section-title(@click="show.history = !show.history")
    h3.capitalize Historial

  transition(name="slide-fade")
    .section-container(v-if="show.history")
      .list-items.dark.capitalize
        .item-history Estado
        .item-history Actualizado Por
        .item-history Fecha

      .list-items(v-if="dataOriginal.createdBy")
        .item-history.capitalize Creado
        .item-history
          shNameUser(:dni="dataOriginal.createdBy")
        .item-history {{ dateTime(dataOriginal.createdAt) }}

      .list-items(v-if="dataOriginal.declinedBy")
        .item-history.capitalize {{ text.tables.declined }}
        .item-history
          shNameUser(:dni="dataOriginal.declinedBy")
        .item-history {{ dateTime(dataOriginal.declinedAt) }}

      .list-items(v-if="dataOriginal.approvedBy")
        .item-history.capitalize {{ text.tables.approved }}
        .item-history
          shNameUser(:dni="dataOriginal.approvedBy")
        .item-history {{ dateTime(dataOriginal.approvedAt) }}

      .list-items(v-if="dataOriginal.paidBy")
        .item-history.capitalize {{ text.tables.paid }}
        .item-history
          shNameUser(:dni="dataOriginal.paidBy")
        .item-history {{ dateTime(dataOriginal.paidAt) }}

      .list-items(v-if="dataOriginal.packedBy")
        .item-history.capitalize {{ text.tables.packed }}
        .item-history
          shNameUser(:dni="dataOriginal.packedBy")
        .item-history {{ dateTime(dataOriginal.packedAt) }}

      .list-items(v-if="dataOriginal.sentBy")
        .item-history.capitalize {{ text.tables.sent }}
        .item-history
          shNameUser(:dni="dataOriginal.sentBy")
        .item-history {{ dateTime(dataOriginal.sentAt) }}

  .section-title(@click="show.delivery = !show.delivery")
    h3
      span.capitalize Entregas {{ dataOriginal.deliveries && dataOriginal.deliveries.length ? `(${dataOriginal.deliveries.length})` : '' }}

  transition(name="slide-fade")
    .section-container(v-if="show.delivery")
      .list-items.dark.capitalize(v-if="dataOriginal.deliveries ? dataOriginal.deliveries.length : false")
        .item-delivery {{ text.tables.delivery }}
        .item-delivery {{ text.tables.state }}
        .item-delivery {{ text.tables.conveyor }}
        .item-delivery {{ text.tables.tracking }}
        .item-delivery {{ text.tables.createdAt }}
        shExpandButton.hidden(:expand="show.delivery")

      shDelivery(v-for="(delivery, index) in sortedDeliveries" :delivery="delivery" :text="text" :conveyors="conveyors" :key="delivery.delivery")
</template>

<script>
import mForm from '@/mixins/form'
import mFilters from '@/mixins/filters'
import mDB from '@/mixins/db'
import gql from '@my/graphql'
import gqlOrder from '@/graphql/order'
import gqlProduct from '@/graphql/product'
import gqlRefund from '@/graphql/refund'
import gqlChange from '@/graphql/change'
import shInputList from '@/components/elements/InputList'
import shInputListNumber from '@/components/elements/InputListNumber'
import shSelectList from '@/components/elements/SelectList'
import shInputImageList from '@/components/elements/InputImageList'
import shInputImage from '@/components/elements/InputImage'
import shProduct from '@/components/ecommerce/Product'
import shNameUser from '@/components/elements/NameUser'
import shExpandButton from '@/components/elements/ExpandButton'
import modals from '@my/store/modals'
import router from '@my/router'
import { changeHasRemit } from '@/helpers/remit'
import { parseProductCode } from '@/helpers/packSearch'
import shDelivery from './Delivery.vue'

export default {
  name: 'FormOrder',

  mixins: [mForm, mFilters, mDB],

  components: { shSelectList, shInputImageList, shInputImage, shInputList, shInputListNumber, shProduct, shNameUser, shExpandButton, shDelivery },

  props: {
    title: String,
    fillData: Boolean,
    dataOriginal: Object
  },

  data () {
    return {
      dataForm: {
        order: '',
        status: '',
        name: '',
        phones: [],
        address: '',
        location: '',
        department: '',
        methodPay: '',
        methodPayCost: 0,
        deliveryCost: [],
        conveyor: '',
        conveyorCost: 0,
        codeName: '',
        codeType: '',
        codePercent: 0,
        codeValue: 0,
        tip: 0,
        deliveryTime: '',
        isWholesaler: false,
        isDropshipping: false,
        deliveryMan: '',
        deliveryTracking: [],
        mpCode: '',
        cart: [],
        declinedBy: '',
        declinedAt: '',
        approvedBy: '',
        approvedAt: '',
        paidBy: '',
        paidAt: '',
        sentBy: '',
        sentAt: '',
        observations: []
      },
      resolver: 'change',
      key: 'change',
      gql: gqlChange,
      deliverySchedule: [{ value: '8-21', option: '🌞 8:00 a.m. - 🌚 9:00 p.m.' }, { value: '8-20', option: '🌞 8:00 a.m. - 🌛 8:00 p.m.' }, { value: '8-13', option: '🌞 8:00 a.m. - 😎 1:00 p.m.' }, { value: '13-20', option: '😎 1:00 p.m. - 🌛 8:00 p.m.' }, { value: '13-21', option: '😎 1:00 p.m. - 🌚 9:00 p.m.' }],
      communities: ['no conozco la localidad', 'bosa', 'candelaria', 'chapinero', 'engativá', 'fontibón', 'kennedy', 'los mártires', 'puente aranda', 'rafael uribe', 'san cristóbal', 'santa fe', 'santa isabel', 'suba', 'teusaquillo', 'tunjuelito', 'usaquén', 'usme'],
      addProducts: {},
      product: '',
      productCheck: '',
      delete: ['change', 'order', 'cart', 'createdAt', 'updatedAt', 'declinedAt', 'declinedBy', 'approvedAt', 'approvedBy', 'paidAt', 'paidBy', 'sentAt', 'sentBy', 'packedAt', 'packedBy', 'deliveryTracking', 'payManual', 'observations', 'collectedAt', 'collectedBy', 'collectedValue', 'payU', 'deliveries', 'refund', 'recoveredAt', 'isSale', 'dni', 'name', 'originalProducts', 'newProducts', 'reasons', 'waitPackage', 'packReceived', 'packReceivedAt', 'packReceivedBy', 'expirationDate', 'remitData', 'remitDataGenerated', 'dataLocked'],
      manualPay: {
        methodPay: '',
        value: ''
      },
      pack: {
        code: '',
        currentTier: '',
        sounds: {
          beepError: 'beep_error.mp3',
          beep: 'beep.mp3',
          error: 'error.mp3',
          tier: 'tier.mp3',
          product: 'product.mp3'
        }
      },
      observation: {
        observation: '',
        type: ''
      },
      show: {
        observations: false,
        products: false,
        data: false,
        pay: false,
        history: false,
        delivery: false,
        refund: false,
        invoice: false,
        change: false,
        productsChange: false,
        dataChange: false
      },
      refund: {
        accountOwnerDni: '',
        accountOwnerDniType: '',
        accountOwnerName: '',
        type: '',
        types: [
          { key: '0', value: 'Derecho al rectracto (aplica hasta 5 días después de que le llegó el producto)' },
          { key: '1', value: 'El pedido llegó tarde' },
          { key: '2', value: 'El pedido no llegó' },
          { key: '3', value: 'No le gustó los productos' },
          { key: '4', value: 'No le quedaron los productos' },
          { key: '5', value: 'Producto fuera de stock' },
          { key: '6', value: 'Envió dinero de más' },
          { key: '7', value: 'Devolución de propina' },
          { key: '6', value: 'El producto llegó dañado o defectuoso' }
        ],
        value: '',
        observation: '',
        method: '',
        account: '',
        accountType: ''
      },
      personType: 'natural',
      documentType: 'cc',
      sendEmail: false,
      statesSpanish: {
        approved: 'aprobada',
        declined: 'rechazada',
        pending: 'pendiente',
        failed: 'fallida',
        reversed: 'reversada',
        retained: 'retenido',
        inited: 'iniciada',
        expired: 'caducada',
        abandoned: 'abandonada',
        cancelled: 'cancelada',
        error: 'error'
      },
      audios: {
        beepError: '',
        beep: '',
        error: '',
        tier: '',
        product: ''
      },
      sounds: {
        beepError: 'beep_error.mp3',
        beep: 'beep.mp3',
        error: 'error.mp3',
        tier: 'tier.mp3',
        product: 'product.mp3'
      },
      sizes: {
        xs: '26',
        s: '28',
        m: '30',
        l: '32',
        xl: '34',
        xxl: '36'
      }
    }
  },

  created () {
    if (this.fillData) this.dataForm = this.copyObject(this.dataOriginal)
  },

  methods: {
    updateProduct ({ product, quantity, index }) {
      if (this.addProducts[product]) {
        const quantityAvailable = this.addProducts[product].quantityAvailable
        this.$set(quantityAvailable, index, quantityAvailable[index] - quantity)
      }
    },

    sendForm () {
      if (!this.fillData) {
        this.newOrder()
      } else {
        this.updateOrder()
      }
    },

    newOrder () {
      this.newData(this.gql, this.resolver, this.key)
    },

    updateOrder () {
      const update = this.dataUpdate()

      if (update && this.buyerDataLocked) {
        const lockedFields = ['name', 'phones', 'address', 'location', 'department']

        if (lockedFields.some(field => update[field] !== undefined)) {
          modals.showMessage({
            message: 'No se pueden modificar nombre, teléfono, dirección, ciudad o departamento porque ya se generó un remite.',
            type: 'error'
          })
          this.dataForm = this.copyObject(this.dataOriginal)
          return
        }
      }

      this.updateData(this.gql, this.resolver, this.key)
    },

    async unlockChangeData () {
      const mutation = gqlChange.UNLOCK_CHANGE_DATA
      const change = this.dataOriginal.change

      const response = await gql.mutate(mutation, { change })

      if (response) {
        modals.showMessage({ message: 'Cambio desbloqueado correctamente' })
      }
    },

    printRemit () {
      this.$store.commit('setPrintReturnAddress', {
        changes: [this.dataOriginal],
        remitOnly: true
      })
      router.goToPrintReturnAddress()
    },

    deleteOrder () {
      this.deleteData(this.gql, this.resolver, this.key)
    },

    async addProduct () {
      const query = gqlProduct.GET_BY_PRODUCT
      const product = this.product.toLowerCase().trim()

      if (!product) return

      const response = await gql.query(query, { product }, false)

      if (!response) return
      if (!response.data || !response.data.getByProduct) return

      const productFind = response.data.getByProduct
      if (productFind) this.$set(this.addProducts, productFind.product, productFind)

      this.product = ''
    },

    playSoundProduct () {
      if (!this.audios.beep) {
        this.audios.beep = this.playSound(this.sounds.beep)
      } else {
        this.audios.beep.play()
      }

      if (!this.audios.product) {
        this.audios.product = this.playSound(this.sounds.product)
      } else {
        this.audios.product.play()
      }
    },

    playSoundError () {
      if (!this.audios.beepError) {
        this.audios.beepError = this.playSound(this.sounds.beepError)
      } else {
        this.audios.beepError.play()
      }

      if (!this.audios.error) {
        this.audios.error = this.playSound(this.sounds.error)
      } else {
        this.audios.error.play()
      }
    },

    processCode (codeString) {
      const product = parseProductCode(codeString)

      if (!product) {
        this.playSoundError()
        return
      }

      return product
    },

    async checkProduct () {
      const product = this.processCode(this.productCheck.trim())
      if (!product) {
        this.productCheck = ''
        return
      }

      const mutation = gqlChange.CHECK_PRODUCT_CHANGE
      const change = this.dataForm.change

      const response = await gql.mutate(mutation, { change, product: product.product, size: product.size })

      if (response) {
        this.playSoundProduct()
      } else {
        this.playSoundError()
      }

      this.productCheck = ''
    },

    async addPayManual () {
      const query = gqlChange.ADD_PAY_MANUAL
      const change = this.dataForm.change

      const response = await gql.mutate(query, { change, value: this.manualPay.value, methodPay: this.manualPay.methodPay })

      if (response) modals.showMessage({ message: `Se agregó el pago del cambio ${change} correctamente` })
    },

    async approvePayManual (payIndex) {
      const query = gqlChange.APPROVE_PAY_MANUAL
      const change = this.dataForm.change

      const response = await gql.mutate(query, { change, payIndex })

      if (response) modals.showMessage({ message: `Se aprobó el pago del cambio ${change} correctamente` })
    },

    async declinePayManual (payIndex) {
      const query = gqlChange.DECLINE_PAY_MANUAL
      const change = this.dataForm.change

      const response = await gql.mutate(query, { change, payIndex })

      if (response) modals.showMessage({ message: `Se declinó el pago del cambio ${change} correctamente` })
    },

    async checkStatePayU (payIndex, platform) {
      const query = gqlOrder.CHECK_STATE_PAY_U
      const change = this.dataForm.change

      const response = await gql.mutate(query, { change, payIndex, platform })

      if (response) modals.showMessage({ message: `Estado actualizado correctamente` })
    },

    async pickProduct (pick) {
      const { product, tier, size } = pick
      const mutation = gqlChange.PICK_PRODUCT_CHANGE
      const change = this.dataForm.change

      const response = await gql.mutate(mutation, { change, product, tier, size })

      if (response) modals.showMessage({ message: `Se alistó el producto ${product} en talla ${size} en el nivel ${tier} del cambio ${change} correctamente` })
    },

    async unpickProduct (pick) {
      const { product, tier, size } = pick
      const mutation = gqlChange.UNPICK_PRODUCT_CHANGE
      const change = this.dataForm.change

      const response = await gql.mutate(mutation, { change, product, tier, size })

      if (response) modals.showMessage({ message: `Se desalistó el producto ${product} en talla ${size} en el nivel ${tier} del cambio ${change} correctamente` })
    },

    async addObservation () {
      const mutation = gqlChange.ADD_OBSERVATION
      const change = this.dataForm.change

      const response = await gql.mutate(mutation, { change, observation: this.observation.observation, type: this.observation.type })

      if (response) {
        modals.showMessage({ message: `Observación agregada correctamente` })
        this.observation.observation = ''
        this.observation.type = ''
      }
    },
    async newDelivery (order, type) {
      const mutation = gqlOrder.NEW_DELIVERY

      if (!order) return

      const response = await gql.mutate(mutation, { order, type })

      if (response) modals.showMessage({ message: `Se agregó una nueva entrega para orden ${order}` })
    },

    async newRefund () {
      const mutation = gqlRefund.NEW
      const order = this.dataOriginal.order
      const { type, observation, value, method, account, accountType, accountOwnerDni, accountOwnerDniType, accountOwnerName } = this.refund
      const response = await gql.mutate(mutation, { order, type, value, method, observation, account, accountType, accountOwnerDni, accountOwnerDniType, accountOwnerName })

      if (response) {
        modals.showMessage({ message: `Se creó un nuevo reembolso para la orden ${order}` })
        const refund = this.refund
        refund.type = ''
        refund.value = ''
        refund.observation = ''
        refund.method = ''
        refund.account = ''
        refund.accountType = ''
        refund.accountOwnerName = ''
        refund.accountOwnerDni = ''
        refund.accountOwnerDniType = ''
      }
    },

    async newChange () {
      const mutation = gqlChange.NEW
      const order = this.dataOriginal.order
      const response = await gql.mutate(mutation, { order })

      if (response) {
        modals.showMessage({ message: `Se creó un nuevo cambio para la orden ${order}` })
      }
    },
    copyChange () {
      this.copyNavigator(`${this.domain}/c/${this.dataForm.change}`)
      modals.showMessage({ message: `La URL de la orden ${this.dataForm.change} ha sido copiada` })
    },
    copyNavigator (text) {
      try {
        this.animationCopy = true
        const type = 'text/plain'
        const blob = new Blob([text], { type })
        const data = [new window.ClipboardItem({ [type]: blob })]
        navigator.clipboard.write(data)
      } catch (error) {
        console.log('Característica sólo soportada en Chrome')
      }
    },
    showSection (section) {
      const event = window.event
      if (event.target.className === 'section-title' || event.target.localName === 'h3') this.show[section] = !this.show[section]
    }
  },

  computed: {
    buyerDataLocked () {
      return !!(this.dataOriginal && this.dataOriginal.dataLocked)
    },

    hasRemit () {
      return changeHasRemit(this.dataOriginal)
    },

    unlockChangeDataConfirmation () {
      return 'Revisa los datos: ya se generó el remite para este cambio. Debes avisar en bodega antes de modificar la información'
    },

    totals () {
      console.log(this.dataForm.originalProducts)
      return this.getTotals(this.dataForm.originalProducts)
    },

    totals1 () {
      return this.getTotals(this.dataForm.newProducts)
    },

    total () {
      return this.getTotal(this.dataForm, this.totals)
    },

    total1 () {
      return this.getTotal(this.dataForm, this.totals1)
    },

    discount () {
      if (!this.dataForm.codeName) return 0
      if (this.dataForm.codeType === 'percent') {
        return this.total * this.dataForm.codePercent / 100
      } else {
        return this.dataForm.codeValue
      }
    },

    addons () {
      return (this.dataForm.tip || 0) + (this.dataForm.methodPayCost || 0) + (this.dataForm.conveyorCost || 0)
    },

    conveyors () {
      return this.$store.state.variables.conveyors
    },

    sortedDeliveries () {
      const deliveries = this.dataOriginal.deliveries
      if (!deliveries || !deliveries.length) return []
      return deliveries.slice().sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
    },

    methods () {
      return [...this.$store.state.variables.methods, 'cash']
    },

    totalPayManual () {
      if (!this.dataForm.payManual || !this.dataForm.payManual.length) return 0
      return this.dataForm.payManual.reduce((total, pay) => {
        if (pay.state === 'approved') total += pay.value
        return total
      }, 0)
    },

    totalPayU () {
      if (!this.dataForm.payU || !this.dataForm.payU.length) return 0
      return this.dataForm.payU.reduce((total, pay) => {
        if (pay.state === 'approved') total += pay.value
        return total
      }, 0)
    },

    text () {
      return this.$store.state.languages.language().order
    },

    quantitySale () {
      return 3
    }
  },

  watch: {
    dataOriginal: {
      handler () {
        if (this.fillData) this.dataForm = this.copyObject(this.dataOriginal)
      },
      deep: true
    }
  }
}
</script>

<style lang="stylus" scoped>
.form-order
  position relative

.preview-text
  margin 1em 0

.products-order-container
  display inline-flex
  justify-content center
  flex-wrap wrap
  gap 3em 1em
  margin 2em 0

.clone-link
  font-size 1.2em

.payU-pays, .manual-pays
  display flex
  justify-content space-between
  align-items center

.buttons-pay-manual
  display inline-flex
  margin .5em 0
  gap 1em

.observation
  display flex
  justify-content space-between

.observation-observation
  flex-basis 40%
  text-align left

.observation-type
  flex-basis 20%

.observation-created-at
  flex-basis 20%

.observation-created-by
  flex-basis 20%
  text-align right

.section-title
  display inline-flex
  justify-content space-between
  cursor pointer
  align-items center
  gap 1em
  text-align center
  width 100%
  padding 0 1em

.section-title h3
  text-align left

.method-pay-image
  height 1.5em

.platform-pay-image
  height 1.3em

.platform-pay-image.epayco
  height 1em

.item-pay-manual
  flex-basis 14.2%

.item-pay-u
  flex-basis 14.2%

.item-pay-u-order-id
  font-size 0.8rem
  color red

.pay-u-container
  margin-bottom 2em

.item-history
  flex-basis 33.333%

.item-delivery
  flex-basis 18%

.item-refund
  flex-basis 15%

.pay-u-container, .pay-manual
  overflow-x scroll
  overflow-y none
  padding-bottom 2em

.buttons-product
  display flex
  flex-wrap wrap
  justify-content flex-end
  gap .5em

.form-section.form-order-actions
  flex-direction row
  flex-wrap nowrap
  justify-content flex-start
  align-items center
  gap .5em
</style>



// WEBPACK FOOTER //
// src/components/pages/change/Form.vue